import React from "react";
import R14, {
  TextInputField,
  SubmitButton,
  StyleSheet,
  ScreenLayout,
  Form,
  Image,
  Text,
  View,
  Surface,
  SafeAreaView,
  AsyncStorage,
  AsyncSessionStorage,
  Dimensions
} from "../core";
import Touchable from "../components/TouchableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import ModalPopUp from "../components/ModalPopUp";
import RSAencryption from "../utils/RSAencryption";
import CommonValidators from "../utils/CommonValidators";
import CommonUtility from "../utils/CommonUtility";
import { LOGIN_TYPE, MANAGE_PASSWORD, VERSION_NO, MESSAGE_TYPE } from "../constant/app.data.constant";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import TooltipComponent from "../components/TooltipComponent";
import PopupModalComponent from "../components/PopupModalComponent";
import { CommonString } from "../constant/appCommonText";
import Linking from "../utils/Linking";
import { RESET_PWD_LINK } from "../constant/app.constant";

import mainImg from "../assets/images/mainImg.png";
import mainImgIpad from "../assets/images/mainImg-ipad.png";
import XBPlogo from "../assets/images/NewXbpLogo150.png";
import hideEyecon from "../assets/images/hideEyecon.png";
import eyecon from "../assets/images/eye.png";
const signInLocation = "XBP";

export default R14.connect(
  class LoginScreen extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoding: false,
        rememberMe: false,
        showPassword: true,
        changePasswordModalshowPassword: true,
        showNewPassword: true,
        showNewConfirmPassword: true,
        isVisible: false,
        isFacebookModalVisible: false,
        isGoogleModalVisible: false,
        alertMessage: "Your account is locked, kindly try after 5 hours",
        captchaValue: "Hide",
        bEnforcePasswordChange: this.props.bEnforcePasswordChange,
        disableSubmitButton: true,
        isModalTimeoutVisible: false,
        isInactive: true,
        IsInValidReturnUrl: false,
        hasChangedUserName: false
      };
      // Idle Timer
      this.idleTimer = null;
      this.intervalId = null
      this.handleOnAction = this.handleOnAction.bind(this);
      this.handleOnActive = this.handleOnActive.bind(this);
      this.handleOnIdle = this.handleOnIdle.bind(this);
      this.ttl = 60000 * 5; //  1 day = 60000 * 60  * 24

      this.initialData = {
        payerDetails: this.props.payerDetails,
      };
    }

    async componentDidMount() {     
      await AsyncStorage.removeItem(CommonString.LOCAL_STORAGE_PROFILE);
      let XBPUsername = null;
      let username = null;
      if (!!(await CommonUtility.getWithExpiry("XBPUsername"))) {
        XBPUsername = JSON.parse(await AsyncStorage.getItem("XBPUsername"));
      }
      if (!!(await CommonUtility.getWithExpiry("username"))) {
        username = JSON.parse(await AsyncStorage.getItem("username"));
      }
      
      await AsyncStorage.clear();
      await AsyncSessionStorage.clear();
      AsyncStorage.setItem(CommonString.LOCAL_STORAGE_HOMESCREEN, this.props.r14.navigation.activeRouteName);
      if (!!XBPUsername) await AsyncStorage.setItem("XBPUsername", JSON.stringify(XBPUsername));
      if (!!username) await AsyncStorage.setItem("username", JSON.stringify(username));
      this.intervalId = setTimeout(
        async () => {
          await this.setRememberMe(false);
        },100);
      await this.props.app.dm.dashboard.resetDashboardDomain();
    }

    componentWillUnmount() {
      if(this.intervalId)
      clearTimeout(this.intervalId)
    }

    async isT2pReturnUrl() {
        let form = this.props.app.ui.form("loginForm");
        let returnUrl = this.props.app.route._location.search;
        if (returnUrl.indexOf("t2p") > -1) {
            const t2pPayerId = await this.props.app.dm.textToPay.decryptTextToPayMetadata(returnUrl);
            form.elmts.username.setValue(t2pPayerId[0].trim())
        } else return false
    }


    changePasswordModaltoggleShowPassword() {
      this.setState({ changePasswordModalshowPassword: !this.state.changePasswordModalshowPassword });
    }
    toggleShowNewPassword() {
      this.setState({ showNewPassword: !this.state.showNewPassword });
    }
    toggleShowNewConfirmPassword() {
      this.setState({ showNewConfirmPassword: !this.state.showNewConfirmPassword });
    }

    async setRememberMe(loginMode, userName, scode) {
      const getStoredData = await CommonUtility.getWithExpiry("XBPUsername");
      let encrScode = !!getStoredData ? scode : RSAencryption.EnctyptString(scode);
      if (!!loginMode) {
        this.state.rememberMe
          ? await CommonUtility.setWithExpiry("XBPUsername", userName, this.ttl, encrScode)
          : await CommonUtility.setWithExpiry("XBPUsername", "", 0);
      } else {
        if (!!getStoredData) {
          if (!!!getStoredData.isEncrypt) {
            await CommonUtility.setWithExpiry("XBPUsername", "", 0);
          }
          else {
          let form = this.props.app.ui.form("loginForm");
          form.elmts.username.setValue(getStoredData.value);
          form.elmts.password.setValue(getStoredData.scode);
          this.setState({ rememberMe: true, hasChangedUserName: false });
        }
      }
    }
    await this.isT2pReturnUrl()
  }

    async setUsername(val) {
      const getStoredData = await CommonUtility.getWithExpiry("XBPUsername");

      if (!!getStoredData && !!getStoredData.value && !!val && getStoredData.value.toLowerCase().trim() === val.toLowerCase().trim()) {
        let form = this.props.app.ui.form("loginForm");
        form.elmts.username.setValue(getStoredData.value);
        form.elmts.password.setValue(getStoredData.scode);
        this.setState({
          hasChangedUserName: false,
          rememberMe: true
        })
      }
    }

    toggleRememberMe() {
      this.setState({ rememberMe: !this.state.rememberMe });
    }

    // NOTE: Handling Submit on Login press. New
    handleSubmit = async (form) => {

      if (!!this.props.remembermeUsername) {
        const getStoredData = await CommonUtility.getWithExpiry("XBPUsername");
        if (!!getStoredData && !!getStoredData.value) {
          if (form.values.username.toLowerCase().trim() !== getStoredData.value.toLowerCase().trim()) {
            if (!!!this.state.hasChangedUserName) {
              form.elmts.password.setValue("");
              this.setState({
                hasChangedUserName: true,
                rememberMe: false
              });
              return false;
            }
            else
            {
              await AsyncStorage.removeItem("XBPUsername");
            }
          }
          else {
            form.elmts.password.setValue(getStoredData.scode);
            form.elmts.password.setError(null);
            this.setState({
              hasChangedUserName: false
            });
          }
        }
      }

      this.setState({ isLoding: true });
      const recaptchaValue = this.state.captchaValue;
      if (recaptchaValue === "") {
        this.props.app.ui.form("loginForm").addError("Please select recaptcha.");
        this.setState({ isLoding: false });
        return false;
      } else {
        let resultData = await this.props.app.dm.userLoginDomain.validateCaptcha(recaptchaValue);
        if (!!resultData && !resultData.success) {
          this.props.app.ui.form("loginForm").addError("Please re-select recaptcha.");
          this.setState({ isLoding: false });
          //this.recaptcha.reset();
          return false;
        }; 
        if (!!resultData && resultData.success) {
          let reqBody = {
            password: form.values.password,
            username: form.values.username.toLowerCase().trim(),
            loginType: LOGIN_TYPE.NORMAL,
            signInLocation: signInLocation,
          };
          try {
            let {isLoggedIn, isAlreadySessionActive} = await this.props.app.dm.userSession.loginAuth(reqBody);
            if(!!isAlreadySessionActive){
              this.props.app.dm.userSession.setState({
                isAlreadySessionActive: true,
                sessionInActive: false
              });
              return false;
            } else if (!!isLoggedIn) {
              this.setRememberMe(true, form.values.username, form.values.password)
              await this.redirectToReturnUrl();
              return false;
            } else {
              this.props.app.ui.form("loginForm").addError("Invalid User Name/Password");
            }
          } catch (err) {
            if (err.error === "custom")
              this.setState({
                isVisible: true,
                alertMessage: err.message,
              });
            else this.props.app.ui.form("loginForm").addError(err.message);

          } finally {
            this.setState({ isLoding: false });
            return false;
          }
        }
      }
    };

    redirectToReturnUrl = async () => {
      let returnUrl = this.props.app.route._location.search;
      if (returnUrl.indexOf("?ReturnUrl=") > -1) {
        if (returnUrl.indexOf("bill-details") > -1) {
          let threadId = returnUrl.split("/");
          threadId = threadId[threadId.length - 1];
          await this.props.app.dm.dashboard.setCompiledMsgList();
          const { compiledMsgList } = this.props.app.dm.dashboard.state;
          if (!!compiledMsgList.length) {
            let item = compiledMsgList.filter((message) => message.threadId === threadId);
            if (!!item.length) {
              // threadId = threadId.replaceAll("#", ">>");
              this.props.app.dm.billDetails.setState({
                billDetails: item[0]
              });
              AsyncStorage.setItem(CommonString.LOCAL_STORAGE_HOMESCREEN, "dashboard");
              this.props.app.nav.to("billDetailsRoute", { threadId: threadId });
              return false;
            } else
              this.setState({
                isVisible: true,
                IsInValidReturnUrl: true,
                alertMessage: "Invalid Bill Reference",
              });
          } else
            this.setState({
              isVisible: true,
              IsInValidReturnUrl: true,
              alertMessage: "Invalid Bill Reference",
            });
        } else if (returnUrl.indexOf("medical-bills") > -1) {
          let uid = returnUrl.split("/");
          uid = uid[uid.length - 1];
          this.props.app.nav.to("uploadedBillsRoute", { uid: uid });
          return false;
        } else if(returnUrl.indexOf("t2p") > -1) {
          let msgMetaIdentifier = returnUrl.split("/");
          msgMetaIdentifier= msgMetaIdentifier[msgMetaIdentifier.length - 1]
          this.props.app.nav.to("textToPay", {messageMetaIdentifier: msgMetaIdentifier})
        } else
          this.setState({
            isVisible: true,
            IsInValidReturnUrl: true,
            alertMessage: "Invalid Bill Reference",
          });
      } else {
        this.props.app.nav.to("dashboard");
      }
    };

    toggleShowPassword() {
      this.setState({ showPassword: !this.state.showPassword });
    }
    onClose = async () => {
      const { IsInValidReturnUrl } = this.state;
      if (!!IsInValidReturnUrl) {
        this.setState({
          isVisible: false,
          IsInValidReturnUrl: false,
          alertMessage: "Your account is locked, kindly try after 5 hours",
        });
        // return <Redirect to="dashboard" />;
        this.props.app.nav.to("dashboard");
      } else this.setState({ isVisible: false });
    };
    facebookModalClose = async () => {
      this.setState({ isFacebookModalVisible: false });
    };
    googleModalClose = async () => {
      this.setState({ isGoogleModalVisible: false });
    };

    loginWithFacebook = () => {
      this.setState({ isFacebookModalVisible: true });
    };
    loginWithGoogle = () => {
      this.setState({ isGoogleModalVisible: true });
    };
    onChangeRecaptcha = async (value) => {
      if (value) {
        this.setState({ captchaValue: value });
      } else {
        this.recaptcha.reset();
      }
    };

    // SECTION: Change Password.
    cancelChangePassword = () => {
      this.props.app.nav.to("login");
    };

    // NOTE: On Change Password Button
    onChangePassword = async (form) => {
      this.props.app.ui.progressIndicator.show();
      // NOTE: Clear all validation messages
      form.elmts.currentPassword.setError("");
      form.elmts.newPassword.setError("");
      form.elmts.confirmPassword.setError("");

      let bIsCurrentPasswordValid = true;
      let bNewPasswordCriteriaMatched = this.bIsNewPasswordValid();
      let bNewPasswordsMatched = this.bNewConfirmPasswordsMatch();
      let bOldNewPasswordDifferent = this.bCurrentNewPasswordDifferent();

      if (!bIsCurrentPasswordValid) {
        form.elmts.currentPassword.setError("Current Password is Incorrect.");
        this.props.app.ui.progressIndicator.hide({ timeout: 750 });
        return false;
      } else {
        form.elmts.currentPassword.setError("");
      }

      if (!bNewPasswordCriteriaMatched) {
        form.elmts.newPassword.setError("Enter a valid password");
        this.props.app.ui.progressIndicator.hide({ timeout: 750 });
        return false;
      } else {
        form.elmts.newPassword.setError("");
      }

      if (!bNewPasswordsMatched) {
        form.elmts.confirmPassword.setError("Entered Password not Matched.");
        this.props.app.ui.progressIndicator.hide({ timeout: 750 });
        return false;
      } else {
        form.elmts.confirmPassword.setError("");
      }

      if (!bOldNewPasswordDifferent) {
        form.elmts.newPassword.setError("Can’t use password used in recent past.");
        this.props.app.ui.progressIndicator.hide({ timeout: 750 });
        return false;
      } else {
        form.elmts.newPassword.setError("");
      }

      let isValid = bIsCurrentPasswordValid && bNewPasswordCriteriaMatched && bNewPasswordsMatched && bOldNewPasswordDifferent;
      if (isValid) {
        let userInputBody = {
          handleType: MANAGE_PASSWORD.CHANGE_PASSWORD,
          pid: JSON.parse(this.initialData.payerDetails).pid,
          oldPassword: form.elmts.currentPassword.value,
          newPassword: form.elmts.confirmPassword.value,
          signInLocation: signInLocation,
        };

        let changePassword = await this.props.app.dm.userLoginDomain.managePassword(userInputBody);
        if (!!changePassword) {
          this.props.app.dm.commonDomain.showToastr("success", changePassword.message);
          this.props.app.ui.progressIndicator.hide({ timeout: 750 });
          this.props.app.nav.to("pchLogin");
        }
      }
      this.props.app.ui.progressIndicator.hide({ timeout: 750 });
      this.setState({
        changePasswordModalshowPassword: true,
        showNewPassword: true,
        showNewConfirmPassword: true,
      })
    };

    bCheckMandatoryFields = () => {
      let cpForm = this.props.app.ui.form("changePasswordForm");
      if (
        cpForm.elmts.currentPassword.value !== null &&
        cpForm.elmts.currentPassword.value !== "" &&
        cpForm.elmts.newPassword.value !== null &&
        cpForm.elmts.newPassword.value !== "" &&
        cpForm.elmts.confirmPassword.value !== null &&
        cpForm.elmts.confirmPassword.value !== ""
      ) {
        this.setState({
          disableSubmitButton: false,
        });
      } else {
        this.setState({
          disableSubmitButton: true,
        });
      }
    };

    // NOTE: Validate the new password criteria.
    bIsNewPasswordValid = () => {
      let form = this.props.app.ui.form("changePasswordForm");
      let passwordField = form.elmts.newPassword.value;
      let isUpper = false;
      let isNumeric = false;
      let isSpecial = false;
      let minMaxLength = false;
      let bContainsSpace = false;
      let bContainsLowerCase = false;

      // Upper Case check
      if (passwordField.replace(/[^A-Z]/g, "").length > 0) {
        isUpper = true;
      }
      // Numeric Character check
      if (passwordField.replace(/[^0-9]/g, "").length > 0) {
        isNumeric = true;
      }
      // Special Character check
      if (passwordField.replace(/[^#@$!%*?]/g, "").length > 0) {
        isSpecial = true;
      }
      if (passwordField.replace(/[^a-z]/g, "").length > 0) {
        bContainsLowerCase = true;
      }
      // Check if any whitespace.
      if (/\s/.test(passwordField)) {
        bContainsSpace = true;
      }
      // Length Check
      if (passwordField.length >= 8 && passwordField.length <= 15) {
        minMaxLength = true;
      }
      if (bContainsLowerCase && isUpper && isNumeric && isSpecial && minMaxLength && !bContainsSpace) {
        return true;
      } else {
        return false;
      }
    };

    // NOTE: To check whether new and confirm password match.
    bNewConfirmPasswordsMatch = () => {
      let cpForm = this.props.app.ui.form("changePasswordForm");
      if (!(cpForm.elmts.newPassword.value === cpForm.elmts.confirmPassword.value)) {
        return false;
      } else {
        return true;
      }
    };

    // NOTE: To check whether current and new password different.
    bCurrentNewPasswordDifferent = () => {
      let cpForm = this.props.app.ui.form("changePasswordForm");
      if (cpForm.elmts.currentPassword.value === cpForm.elmts.newPassword.value) {
        return false;
      } else {
        return true;
      }
    };
    // SECTION: Route Registration.
    routeToRegistration = (val) => {
      this.props.app.nav.to("registration", { type: val.toLowerCase() });
    };
    // SECTION: Route forgot password.
    routeToForgotPassword = () => {
      Linking.LinkingURL(RESET_PWD_LINK, "_blank");
    };

    // NOTE: Redirect to Registration using Social Media Integration
    goToRegistrationPageWithFB = (val) => {
      this.props.app.nav.to("registration", { type: val.toLowerCase() });
      this.props.app.dm.userSession.setState({
        facebookMediaLoginPID: !this.props.app.dm.userSession.state.facebookMediaLoginPID,
      });
    };

    goToRegistrationPageWithGoogle = (val) => {
      this.props.app.nav.to("registration", { type: val.toLowerCase() });
      this.props.app.dm.userSession.setState({
        googleMediaLoginPID: !this.props.app.dm.userSession.state.googleMediaLoginPID,
      });
    };
    // SECTION: Idle Time out when mandatory password change is enforced.
    handleOnAction(event) { }

    handleOnActive(event) {
      if (this.state.isInactive === false) {
        this.idleTimer.reset();
      }
    }
    // warning modal for session timeout will pop up.
    handleOnIdle = () => {
      if (!!this.state.bEnforcePasswordChange) {
        this.setState({ bEnforcePasswordChange: false });
        this.setState({ isModalTimeoutVisible: true });
        this.setState({ isInactive: true });
        setTimeout(
          function () {
            if (this.state.isInactive && !!this.idleTimer) {
              if (this.idleTimer) {
                this.idleTimer.pause();
              }
              this.props.app.nav.to("login");
            }
          }.bind(this),
          1000 * 3 * 1
        );
      }
    };

    renderIdleTimerPopUpMenu() {
      return (
        <SafeAreaView>
          <View>
            <View>
            <PopupModalComponent
              visibility={this.state.isModalTimeoutVisible}
              bodyWrapper={[styles.sessionExpirPopupBodyWrapper]}
              messageType={MESSAGE_TYPE.info}
              headingIcon={true}
              heading={"Change Password Expiration!"}
              modalContent={[commonStyles.marginTop10, commonStyles.marginBottom10]}
              bodyContent={"You will be redirected to the login screen."}
              okLabel={"Ok"}
              handleOk={this.handleLogoutPress}
              closeLabel={""}
              handleClose={null}
            />
            </View>
          </View>
        </SafeAreaView>
      );
    }

    // NOTE: Enforce Password Change Modal.
    renderEnforcePasswordUpdate() {
      return (
        <SafeAreaView>
          <View>
            <View>
              <ModalPopUp
                visibility={true}
                isFooter={false}
                bodyWrapper={[commonStyles.smallModalBodyWrapper]}
                modalOuterWrapper={styles.modalOuterWrapper}
                heading={"Change Password"}
                modalContent={commonStyles.marT0}
                handleCancel={this.cancelChangePassword}
                closeButton={styles.changePasswordModalCloseBtn}
                modalHeading={[commonStyles.marginBottom24]}>
                <View style={[styles.payNowWrapper]}>
                  <Form
                    name="changePasswordForm"
                    onSubmit={this.onChangePassword}
                    validateBeforeSubmit={true}
                    validators={CommonValidators.getFormValidator()}
                    style={[commonStyles.padding0]}>
                    <View style={styles.passwordFieldContainer}>
                      <TextInputField
                        name="currentPassword"
                        label="Current Password*"
                        required="Enter the current password"
                        style={[commonFontStyles.workSans, commonMetricsStyle.heading6, customCommonStyles.inputHeight]}
                        labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonMetricsStyle.heading6]}
                        labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle]}
                        secure={this.state.changePasswordModalshowPassword}
                        iconRight="eye"
                        onIconRightPress={() => this.changePasswordModaltoggleShowPassword()}
                        onChangeText={this.bCheckMandatoryFields}
                        helperTextStyle={[styles.customHelperTextStyle, commonStyles.helperTextFontStyle, commonFontStyles.workSans]}
                      />
                      {!this.state.changePasswordModalshowPassword ? (
                        <Touchable style={[styles.hideEyeIconWrap]} onPress={() => this.changePasswordModaltoggleShowPassword()}>
                          <View>
                            <Image source={hideEyecon} style={[styles.backgroundImageHideIcon]} />
                          </View>
                        </Touchable>
                      ) : null}
                    </View>
                    <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, customCommonStyles.customInputHolder, styles.passwordFieldContainer]}>
                      <TextInputField
                        name="newPassword"
                        label="New Password*"
                        required="Enter the new password"
                        validator="min8Max15"
                        style={[commonFontStyles.workSans, commonMetricsStyle.heading6, customCommonStyles.inputHeight]}
                        labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonMetricsStyle.heading6]}
                        labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle]}
                        secure={this.state.showNewPassword}
                        iconRight="eye"
                        onIconRightPress={() => this.toggleShowNewPassword()}
                        onChangeText={this.bCheckMandatoryFields}
                        helperTextStyle={[styles.customHelperTextStyle, commonStyles.helperTextFontStyle, commonFontStyles.workSans, styles.longErrorMsg]}
                      />
                      {!this.state.showNewPassword ? (
                        <Touchable style={styles.hideEyeIconWrapNewPassword} onPress={() => this.toggleShowNewPassword()}>
                          <View>
                            <Image source={hideEyecon} style={[styles.backgroundImageHideIcon]} />
                          </View>
                        </Touchable>
                      ) : null}
                      <TooltipComponent
                        toolTipMessage="Enter min 8, max 15 characters at least. 1 uppercase and 1 lower case, 1 numeric with special characters #@$!%*?" />
                    </View>
                    <View style={[styles.passwordFieldContainer]}>
                      <TextInputField
                        name="confirmPassword"
                        label="Confirm Password*"
                        required="Enter the confirm password"
                        validator="min8Max15"
                        style={[commonFontStyles.workSans, commonMetricsStyle.heading6, customCommonStyles.inputHeight]}
                        labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonMetricsStyle.heading6]}
                        labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle]}
                        secure={this.state.showNewConfirmPassword}
                        iconRight="eye"
                        onIconRightPress={() => this.toggleShowNewConfirmPassword()}
                        onChangeText={this.bCheckMandatoryFields}
                        helperTextStyle={[styles.customHelperTextStyle, commonStyles.helperTextFontStyle, commonFontStyles.workSans]}
                      />
                      {!this.state.showNewConfirmPassword ? (
                        <Touchable style={[styles.hideEyeIconWrap]} onPress={() => this.toggleShowNewConfirmPassword()}>
                          <View>
                            <Image source={hideEyecon} style={[styles.backgroundImageHideIcon]} />
                          </View>
                        </Touchable>
                      ) : null}
                    </View>
                    <View style={[commonStyles.marTAuto, commonStyles.flex1]}>
                      <View style={[commonStyles.flexBasis50, commonStyles.marLAuto]}>
                        <SubmitButton
                          key="update"
                          title="Submit"
                          disabled={this.state.disableSubmitButton}
                          style={[commonStyles.blueButton, commonStyles.fullWidth, customCommonStyles.noBoxShadow]}
                          titleTextStyle={[
                            commonStyles.whiteColor,
                            commonStyles.fontWeight500,
                            commonFontStyles.workSans,
                            commonMetricsStyle.heading6,
                          ]}
                        />
                      </View>
                    </View>
                  </Form>
                </View>
              </ModalPopUp>
            </View>
          </View>
        </SafeAreaView>
      );
    }

    render() {
      return (
        <ScreenLayout scrollEnabled style={[commonStyles.flex1]}>
          <View style={styles.mainLogin}>
            <View style={[styles.bgContainer, styles.leftSection]}>
              {Dimensions.get("window").width === 1024 && Dimensions.get("window").height === 1292 ?
                <Image source={mainImgIpad} style={[styles.backgroundImage]} /> :
                <Image source={mainImg} style={[styles.backgroundImage]} />}
            </View>

            <Surface style={[styles.rightSection, customCommonStyles.xbpLoginRightSection]}>
              <View style={[
                styles.logoImageContainer,
                commonStyles.flex1,
                commonStyles.justifyContentCenter,
                commonStyles.flexGrow0,
                commonStyles.alignItemsCenter,]}>
                <Image resizeMode="contain" style={[commonStyles.logoImage]} source={XBPlogo} />
              </View>
              <View style={[styles.loginFormContainer]}>
                <Form
                  name="loginForm"
                  onSubmit={this.handleSubmit}
                  initialValues={this.initialData}
                  validateBeforeSubmit
                  errorTextStyle={[customCommonStyles.helperTextStylecustom, commonStyles.helperTextFontStyle, commonFontStyles.workSans, commonStyles.smallHeading]}
                  style={[styles.paddingTop0, styles.loginFormSection]}>
                  <TextInputField
                    name="username"
                    label="User Name*"
                    required="Enter the User Name"
                    style={[styles.emailField, commonFontStyles.workSans, commonMetricsStyle.heading6, customCommonStyles.inputHeight,]}
                    onChangeText={(val) => this.setUsername(val)}
                    labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonMetricsStyle.exSmallHeading]}
                    labelStyle={[commonStyles.formLabelStyle,customCommonStyles.inputLableStyle]}
                    autoFocus
                    helperTextStyle={[customCommonStyles.helperTextStylecustom, commonStyles.helperTextFontStyle, commonFontStyles.workSans, commonStyles.left0]}
                  />
                  <View style={[styles.passwordFieldContainer, styles.loginFormPasswordContainer, !!!this.props.remembermeUsername ? null : this.state.hasChangedUserName ? null : styles.hideField]}>
                    <TextInputField
                      name="password"
                      label="Password*"
                      secure={this.state.showPassword}
                      required="Enter the Password"
                      style={[styles.passwordField, commonFontStyles.workSans, commonMetricsStyle.heading6, customCommonStyles.inputHeight]}
                      labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonMetricsStyle.exSmallHeading]}
                      labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle]}
                      helperTextStyle={[customCommonStyles.helperTextStylecustom, commonStyles.helperTextFontStyle, commonFontStyles.workSans, commonStyles.left0]}
                    />
                    {!this.state.showPassword ? (
                      <Touchable style={[styles.hideEyeIconWrap, styles.loginForrmHideEyeIconWrap]} onPress={() => this.toggleShowPassword()}>
                        <View style={styles.hideEyeIconContainer}>
                          <Image source={hideEyecon} style={[styles.backgroundImageHideIcon, customCommonStyles.customBackgroundImageHideIcon]} />
                        </View>
                      </Touchable>
                    ) : (
                      <Touchable style={[styles.hideEyeIconWrap, styles.loginForrmHideEyeIconWrap]} onPress={() => this.toggleShowPassword()}>
                        <View style={styles.hideEyeIconContainer}>
                          <Image source={eyecon} style={[styles.backgroundImageHideIcon, customCommonStyles.customBackgroundImageHideIcon, styles.eyecon]} />
                        </View>
                      </Touchable>
                    )
                    }
                  </View>
                  <View style={styles.loginControls} key="viewOne">
                    <SubmitButton
                      title={"Log In"}
                      key="submit"
                      style={[commonStyles.loginButton, customCommonStyles.noBoxShadow]}
                      titleTextStyle={[commonFontStyles.workSans, commonMetricsStyle.heading6, commonStyles.transformNone, commonStyles.whiteColor]}
                      disabled={this.state.isLoding}
                    />
                  </View>
                  <View
                    style={[
                      styles.forgotPasswordSection,
                      commonStyles.flex1,
                      commonStyles.alignItemsEnd,
                      !!!this.props.remembermeUsername ? null : styles.hideField,
                    ]}>
                    <Touchable key="forgotPassword" onPress={() => { this.routeToForgotPassword(); }}>
                      <Text
                        style={[
                          styles.blueLink,
                          commonFontStyles.workSans,
                          commonMetricsStyle.heading6,
                          commonStyles.smallHeading,
                        ]}
                      >
                        Forgot Password?
                      </Text>
                    </Touchable>
                  </View>
                </Form>
                
              </View>
              <View style={[styles.mrgTopAuto, commonStyles.marginBottom10, styles.copyRight]}>
                <Text style={[commonFontStyles.workSans, commonStyles.smallHeading, commonStyles.textAlignCenter, commonStyles.darkGrayColor]}>
                  © {new Date().getFullYear()} Exela Technologies, All Rights Reserved. {VERSION_NO.label}
                </Text>
              </View>
            </Surface>
            {this.state.bEnforcePasswordChange ? this.renderEnforcePasswordUpdate() : null}
            {this.renderIdleTimerPopUpMenu()}
          </View>
          <PopupModalComponent
            visibility={this.state.isVisible}
            bodyWrapper={[commonStyles.smallModalBodyWrapper, styles.modalHeight]}
            messageType={MESSAGE_TYPE.error}
            headingIcon={true}
            heading={this.state.IsInValidReturnUrl ? "Invalid Reference" : "Account Locked"}
            modalContent={[commonStyles.marginTop10, commonStyles.marginBottom10]}
            bodyContent={this.state.alertMessage}
            okLabel={"Ok"}
            handleOk={this.onClose}
            closeLabel={""}
            handleClose={null}
          />
        </ScreenLayout>
      );
    }
  }
);

const styles = StyleSheet.create({
  mainLogin: {
    flex: 1,
    backgroundColor: "#fff",
    height: "100%",
    flexDirection: "row",
    screen: ({ width }) => {
      if (width >= 320 && width <= 359) {
        return {
          height: "auto",
        };
      }
      if (width <= 991) {
        return {
          height: "100%",
          flexDirection: "column",
          flexGrow: 1,
        };
      }
    },
  },
  leftSection: {
    flex: 2,
    display: "flex",
    screen: ({ width }) => {
      if (width <= 1024) {
        return {
          display: "none",
        };
      }
    },
  },
  rightSection: {
    flex: 1,
    flexGrow: 1,
    width: 550,
    maxWidth: 550,
    position: "relative",
    paddingTop: 16,
    height: "100vh",
    overflowX: "auto",
    screen: ({ width, height }) => {

      if (width <= 991) {
        return{
          paddingBottom: 5,
        }
      }
      if (width <= 991) {
        return {
          paddingTop: 20,
          marginTop: 0,
          marginRight: "auto",
          marginBottom: 0,
          marginLeft: "auto",
          maxWidth: 365,
          minWidth: 354,
          boxShadow: "none",
          backgroundColor: "#00000000",
          height: "100%",
        };
      }
    },
  },
  bodyWrapper: {
    screen: ({ width }) => {
      if (width <= 479) {
        return {
          width: "93%",
        };
      }
    },
  },
  invalidReferenceModalBodyWrapper: {
    position: "relative",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          width: "100vw",
          marginTop: "auto",
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        };
      }
    },
  },
  facebookModalBodyWrapper: {
    padding: 0,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    position: "relative",
    screen: ({ width }) => {
      if (width <= 479) {
        return {
          width: "93%",
        };
      }
    },
  },
  googleModalBodyWrapper: {
    paddingTop: 10,
    paddingRight: 24,
    paddingBottom: 24,
    paddingLeft: 24,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    position: "relative",
    minWidth: 300,
    screen: ({ width }) => {
      if (width <= 479) {
        return {
          width: "93%",
        };
      }
    },
  },
  backgroundImage: {
    width: "144%",
    height: "100%",
    display: "block",
    backgroundSize: "cover",
    backgroundPosition: "left center",
    screen: ({ width, height }) => {
      if ((width === 1280) && (height >= 881 && height <= 1024))
        return {
          backgroundPosition: "-90px center",
        };
     if (width === 1024)
        return {
          backgroundPosition: "30% center",
        };
    }
  },
  bgContainer: {
    width: "100%",
    display: "block",
    height: "100vh",
    screen: ({ width }) => {
      if (width <= 768)
        return {
          display: "none",
          width: 0,
        };
    }
  },
  hideEyeIconContainer: {
    width: 38,
    height: 20,
    position: "absolute",
    top: 4,
    right: 10,
  },
  backgroundImageHideIcon: {
    width: 20,
    height: 20,
    display: "block",
    backgroundSize: "cover",
    position: "relative",
    top: 7,
    right: "-7px",
  },
  emailField: {
    width: "100%",
    display: "block",
  },
  passwordField: {
    width: "100%",
    marginBottom: 0,
  },
  loginLogo: {
    width: "100%",
    height: 90,
    marginBottom: 90,
  },
  rememberMeText: {
    marginLeft: -8,
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          marginTop: 15,
        };
      }
    },
  },
  forgotPassword: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: 30,
    marginBottom: 30,
    color: "#37c2ef",
    fontSize: "14",
  },
  forgotLeftSection: {
    textAlign: "right",
    color: "#38c2ef",
    width: "100%",
  },
  loginControls: {
    width: "100%",
    marginTop: 16
  },
  blueLink: {
    color: "#38c2ef",
  },
  createAccount: {
    color: "#38c2ef",
    fontSize: "14",
    textTransform: "none",
    screen: ({ width }) => {
      if (width <= 640) {
        return {
          marginLeft: 0,
        };
      }
    },
  },
  twoCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loginFormContainer: {
    width: "100%",
    padding: 0,
    maxWidth: 343,
    marginTop: 50,
    marginRight: "auto",
    marginBottom: 0,
    marginLeft: "auto",
  },
  logoImageContainer: {
    width: "100%",
    textAlign: "center",
    marginTop: "15%",
    marginRight: "auto",
    marginBottom: 6,
    marginLeft: "auto",
    minHeight: 55,
  },
  mrgTopAuto: {
    marginTop: "auto",
  },
  payNowWrapper: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  btnTexClr: {
    color: "#fff",
  },
  captchaHolder: {
    color: "red",
  },
  forgotPasswordSection: {
    textAlign: "right",
    marginTop: 10,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    position: "relative",
  },
  orSection: {
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderBottomColor: "rgba(186, 186, 186, 1)",
    position: "relative",
    textAlign: "center",
    marginBottom: 22,
  },
  or: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: 50,
    borderTopRightRadius: 50,
    borderBottomLeftRadius: 50,
    borderBottomRightRadius: 50,
    backgroundColor: "#fff",
    position: "relative",
    top: 10,
    paddingTop: 1,
    paddingRight: 5,
    paddingBottom: 1,
    paddingLeft: 5,
    letterSpacing: 0.5,
    fontSize: 14,
  },
  mView: {
    display: "none",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          display: "block",
        };
    },
  },
  loginWithSocialSection: {
    marginTop: 0,
    marginRight: "auto",
    marginBottom: 0,
    marginLeft: "auto",
    maxWidth: 301,
    width: 301,
    screen: ({ width }) => {
      if (width >= 320 && width <= 359) {
        return {
          maxWidth: 252,
          width: 252,
        };
      }
      if (width <= 991) {
        return {
          display: "block",
        };
      }
    },
  },
  loginWithSocialWrap: {
    marginTop: 0,
    marginRight: 16,
    marginBottom: 0,
    marginLeft: 16,
    position: "relative",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          marginRight: 10,
          marginLeft: 10,
        };
      }
    }
  },
  loginWithSocial: {
    display: "flex",
    justifyContent: "center",
    marginTop: 10,
    flexDirection: "column",
  },
  socialButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    minHeight: 35,
    marginBottom: 15,
  },
  facebook: {
    backgroundColor: "#4267b2",
  },
  google: {
    backgroundColor: "#db4437",
  },
  changePasswordModalBodyWrapper: {
    width: 300,
  },
  changePasswordModalCloseBtn: {
    display: "none",
  },
  customHelperTextStyle: {
    position: "static",
  },
  profilePicSection: {
    position: "relative",
  },
  facebookLogo: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  facebookMediaPopupTopSection: {
    paddingTop: 10,
    paddingRight: 25,
    paddingBottom: 10,
    paddingLeft: 24,
  },
  facebookMediaPopupBottomSection: {
    backgroundColor: "#4267B2",
    minHeight: 51,
    borderRadius: "0 0 5px 5px",
  },
  facebookModalFooter: {
    padding: 0,
  },
  googleModalFooter: {
    padding: 0,
  },
  facebookModalCloseBtn: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 9999,
  },
  continueFacebookBtn: {
    height: "auto",
  },
  createNewAcc: {
    position: "static",
    zIndex: 999999999,
    ...StyleSheet.padding(0, 16, 0, 16),
    flexDirection: "column",
    marginTop: "auto",
    screen: ({ width }) => {
      if (width === 1366) {
        return {
          marginTop: 0,
        };
      } else if (width <= 359)
        return {
          marginBottom: 6,
          flexWrap: "nowrap",
          flexDirection: "column",
          padding: 0,
        };
      else if (width >= 360 && width <= 991)
        return {
          justifyContent: "center",
          ...StyleSheet.padding(0, 16, 0, 16),
        };
    },
  },
  copyRight: {
    textAlign: "center",
    marginTop: "auto",
    screen: ({ width,  }) => {
      if (width <= 1024)
        return {
          paddingTop: 5,
          paddingRight: "2%",
          paddingBottom: 0,
          paddingLeft: "2%",
        };
    },
  },
  invalidReferenceModalCloseBtn: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  paddingTop0: {
    paddingTop: 0,
  },
  termsAndConditionsWrapper: {
    marginBottom: 16,
    screen: ({ width, height }) => {
      if (width === 1366) {
        return {
          marginBottom: 5,
        };
      }
      if (width <= 991) {
        return {
          marginBottom: 10,
        };
      }
    },
  },
  hideEyeIconWrap: {
    position: "absolute",
    height: 20,
    width: 20,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    top: 2,
    right: 16,
  },
  loginForrmHideEyeIconWrap: {
    top: 6,
    marginTop: -3,
  },
  termsAndConditions: {
    color: "#38c2ef",
  },
  rememberMeWrap: {
    marginBottom: 7,
  },
  passwordFieldContainer: {
    width: "100%",
    position: "relative",
  },
  loginFormPasswordContainer: {
    marginBottom: 16,
  },
  hideEyeIconWrapNewPassword: {
    position: "absolute",
    height: 30,
    width: 30,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    top: 2,
    right: 56,
  },
  longErrorMsg: {
    width: "120%",
    display: "block",
  },  
  hideField: {
    display: "none",
  },
  loginFormSection: {
    paddingTop: 0,
    paddingRight: 10,
    paddingBottom: 16,
    paddingLeft: 10,
  },
  sessionModelOkBtn: {
    width: 100,
  },
  eyecon:{
    right: -30,
    top: 4,
    width: 15,
    height: 15
  }
});
